export default "__VITE_ASSET__DNv4SCQL__"